/**
 * OVERRIDE EventView.jsx
 * REASON: Adding dates and headtitle above the title of page.
 * DATE: 2023-07-04
 * DEVELOPER: @IFlameing
 */

import EventView from '../../../../components/Theme/EventView';

export default EventView;
